module.exports = __webpack_public_path__ + "static/speisekarte_helmarts-b936763e116958b12bb0ee7ee9daa24b.png";